import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { Container, Row, Col, Visible, Hidden } from "react-grid-system";
import { MarkdownGenerator } from "./../Blocks.js";
import SVG_Perk1 from "./img/percent.svg";
import SVG_Perk2 from "./img/easy.svg";

import SVG_Perk1Grey from "./img/percentGrey.svg";
import SVG_Perk2Grey from "./img/easyGrey.svg";

import IMG_HERO from "./photos/Hero-Banner.jpg";
import IMG_HERO_MOBILE from "./photos/Hero_Mobile.jpg";

import IMG_NEUTRAL_HERO from "./photos/Hero-Banner.neutral.jpg";
import IMG_NEUTRAL_HERO_MOBILE from "./photos/Hero_Mobile.neutral.jpg";

const HeroContainer = styled.div`
  overflow: hidden;
  background-image: url(${process.env.REACT_APP_GENDER_NEUTRAL
    ? IMG_NEUTRAL_HERO
    : IMG_HERO});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  padding-top: 3rem;
  .perks {
    margin-top: 6rem;
    img {
      margin-right: 12px;
    }
    > div > div {
      width: 100%;
      margin: 0 auto !important;
    }
  }
  @media (max-width: 899px) {
    background-image: none;
    padding-top: 0;

    .perks {
      margin-top: 0;

      p.inline-block {
        width: 100%;
      }

      img {
        margin-right: 0;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 899px) {
    background-image: none;
    padding-top: 0;

    .perks {
      margin-top: 0;

      img {
        margin-right: 0;
      }
    }
  }
`;
const btn_style = {
  padding: "1rem 2rem",
  minWidth: "10rem",
};

const PerkStyle = css`
  p {
    font-size: 15px;
    line-height: 1.69;
  }
`;

const HeroTitle = styled.h2`
  position: absolute;
  top: calc(80px + 5%);
  left: 0;
  width: 100%;

  p {
    line-height: 1.5;
  }

  @media (min-width: 768px) {
    top: calc(80px + 10%);
    font-size: 3rem;
  }
`;

const MarkdownWithStyle = MarkdownGenerator({ style: PerkStyle });
const Markdown = MarkdownGenerator();

class Hero extends React.Component {
  static contextTypes = {
    copy: PropTypes.object,
  };
  renderPerk(copy, index = 0) {
    return (
      <React.Fragment>
        <MarkdownWithStyle>{copy && copy.perks[index].body}</MarkdownWithStyle>
      </React.Fragment>
    );
  }
  render() {
    const locale = this.props.match.params.locale;
    const copy = this.context.copy.get("Hero");
    return (
      <HeroContainer className="relative no-gutter color-white bg-lbgt bg-m-white">
        <Visible xs sm>
          <img
            src={
              process.env.REACT_APP_GENDER_NEUTRAL
                ? IMG_NEUTRAL_HERO_MOBILE
                : IMG_HERO_MOBILE
            }
            alt=""
            className="w-100"
            style={
              window.innerWidth < 360
                ? { width: "120%", position: "relative", left: "-10%" }
                : {}
            }
          />
        </Visible>
        <Container
          className="content h-100 py2 mmx0i pmy0i mwi-100"
          style={
            window.innerWidth < 900
              ? { textAlign: "center", position: "initial" }
              : { margin: "20px 1rem 0", position: "initial" }
          }
        >
          <Visible xs sm>
            <HeroTitle className="h1 font-light line-height-2 mmx0">
              <Markdown>{copy && copy.headline}</Markdown>
            </HeroTitle>
          </Visible>

          <Hidden xs sm>
            <Row className="h-100 pt5 pmt0">
              <Col
                md={10}
                lg={8}
                offset={{ lg: 1 }}
                className="h-100 flex flex-wrap items-center pmx0i"
              >
                <div className="w-100 self-center px1">
                  <h2 className="h1 font-light  line-height-2 mmx0">
                    <Markdown>{copy && copy.headline}</Markdown>
                  </h2>
                  <div
                    className="body-large  my2 line-height-5 p1"
                    style={{ maxWidth: "460px" }}
                  >
                    <Markdown>{copy && copy.statement}</Markdown>
                  </div>
                  <div className="">
                    <a
                      href="#products"
                      style={btn_style}
                      className="btn btn-white noHover mb1 mt2 mx1"
                    >
                      {copy && copy.cta_go_to_products}
                    </a>
                    <Link
                      style={btn_style}
                      className="btn btn-alt mb1 mt2 mx1"
                      to={`/${locale}/wizard`}
                    >
                      {copy && copy.cta_find_your_product}
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Hidden>
          <Row className="perks h7 bg-m-white col-m-bg">
            <Col sm={12} md={10} lg={10} offset={{ sm: 0, lg: 1 }}>
              <Row>
                <Col
                  className="flex items-center my2 w-100i"
                  style={
                    window.innerWidth <= 900
                      ? {
                          justifyContent: "center",
                          alignItems: "start",
                          marginTop: "48px",
                        }
                      : {}
                  }
                >
                  <div style={{ width: "100%", maxWidth: "218px" }}>
                    <p className="inline-block align-middle">
                      <img
                        src={
                          window.innerWidth <= 900 ? SVG_Perk1Grey : SVG_Perk1
                        }
                        width={50}
                        alt=""
                        className="fit"
                      />
                    </p>
                    {/* <Col className="my1 color-m-bg" sm={12} md={8}> */}
                    <div
                      className="inline-block align-middle color-m-bg"
                      style={
                        window.innerWidth >= 768 ? { maxWidth: "150px" } : {}
                      }
                    >
                      {this.renderPerk(copy, 0)}
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      maxWidth: "248px",
                    }}
                  >
                    {/* <Col className="my1" sm={12} md={4}> */}
                    <p className="inline-block align-middle">
                      <img
                        src={
                          window.innerWidth <= 900 ? SVG_Perk2Grey : SVG_Perk2
                        }
                        width={50}
                        alt=""
                        className="fit"
                      />{" "}
                    </p>
                    {/* <Col className="" sm={12} md={8}> */}
                    <div
                      className="inline-block align-middle color-m-bg"
                      style={
                        window.innerWidth >= 768 ? { maxWidth: "180px" } : {}
                      }
                    >
                      {this.renderPerk(copy, 1)}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </HeroContainer>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/Home/Hero.js